module.exports = __webpack_public_path__ + "img/magazine_award_banner_2024.cd5922be.svg";